export const UPDATE_MENU = 'menu:updateMenu';

export function updateMenu(newMenu, newData){
    return {
        type: UPDATE_MENU,
        payload: {
            menu: newMenu,
            data: newData
        }
    }
}


// WEBPACK FOOTER //
// ./src/container/actions/menu-action.js